import { useEffect, useRef, useState } from 'react';
import { usePrevious } from '../../../../../hooks/react';

interface IUseFocusedItemParams {
  isPopoverOpen: boolean;
}

export const useFocusedItem = ({ isPopoverOpen }: IUseFocusedItemParams) => {
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const focusedItemRef = useRef<HTMLLIElement>(null);

  const isPopoverOpenBefore = usePrevious(isPopoverOpen);

  useEffect(() => {
    if (!isPopoverOpenBefore && isPopoverOpen) {
      setFocusedIndex(0);

      if (focusedItemRef.current) {
        focusedItemRef.current.focus();
      }
    }
  }, [isPopoverOpen, isPopoverOpenBefore]);

  useEffect(() => {
    if (focusedItemRef.current) {
      focusedItemRef.current.focus();
    }
  }, [focusedIndex]);

  return {
    focusedIndex,
    setFocusedIndex,
    focusedItemRef,
  };
};
